import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const AdminsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('admins'), link: '/admins-list' },
		{ title: t('list') }
	];

	const [admins, setAdmins] = useState([]);
	let adminsListData = {
		head: [t('mobile_number'), t('name'), t('role'), t('permissions'), t('operation')],
		body: admins.map(admin => {
			let permissionsContent = [];
			if(admin.permissions.includes('Admin'))
				permissionsContent.push(t('admins'));
			if(admin.permissions.includes('Usercategories'))
				permissionsContent.push(t('user_categories'));
			if(admin.permissions.includes('Users'))
				permissionsContent.push(t('users'));
			if(admin.permissions.includes('Credits'))
				permissionsContent.push(t('credits'));
			if(admin.permissions.includes('Codes'))
				permissionsContent.push(t('marketing_codes'));
			if(admin.permissions.includes('ReferralChanges'))
				permissionsContent.push(t('referral_changes'));
			if(admin.permissions.includes('Requestcategories'))
				permissionsContent.push(t('request_categories'));
			if(admin.permissions.includes('Requests'))
				permissionsContent.push(t('requests'));
			if(admin.permissions.includes('Stocks'))
				permissionsContent.push(t('stocks'));
			if(admin.permissions.includes('Signals'))
				permissionsContent.push(t('signals'));
			if(admin.permissions.includes('Signalcomments'))
				permissionsContent.push(t('signal_comments'));
			if(admin.permissions.includes('Consultants'))
				permissionsContent.push(t('consultants'));
			if(admin.permissions.includes('Consultationcategories'))
				permissionsContent.push(t('consultation_categories'));
			if(admin.permissions.includes('Consultations'))
				permissionsContent.push(t('consultations'));
			if(admin.permissions.includes('Productcategories'))
				permissionsContent.push(t('product_categories'));
			if(admin.permissions.includes('Products'))
				permissionsContent.push(t('products'));
			if(admin.permissions.includes('Orders'))
				permissionsContent.push(t('product_orders'));
			if(admin.permissions.includes('Contests'))
				permissionsContent.push(t('contests'));
			if(admin.permissions.includes('Contestenrolls'))
				permissionsContent.push(t('forecasts'));
			if(admin.permissions.includes('TopCompetitors'))
				permissionsContent.push(t('the_bests'));
			if(admin.permissions.includes('Banners'))
				permissionsContent.push(t('banners'));
			if(admin.permissions.includes('Settings'))
				permissionsContent.push(t('first_popup'));
			if(admin.permissions.includes('HomeSliderBanners'))
				permissionsContent.push(t('home_slider'));
			if(admin.permissions.includes('DashboardSliderBanners'))
				permissionsContent.push(t('dashboard_slider'));
			if(admin.permissions.includes('Transactioncategories'))
				permissionsContent.push(t('transaction_categories'));
			if(admin.permissions.includes('Transactions'))
				permissionsContent.push(t('transactions'));
			if(admin.permissions.includes('BlogCategories'))
				permissionsContent.push(t('blog_categories'));
			if(admin.permissions.includes('BlogPosts'))
				permissionsContent.push(t('blog_posts'));
			if(admin.permissions.includes('CourseCategories'))
				permissionsContent.push(t('course_categories'));
			if(admin.permissions.includes('Courses'))
				permissionsContent.push(t('courses'));
			return [
				admin.username,
				admin.name || '',
				admin.role || '',
				permissionsContent.join(', '),
				<Link className='btn btn-secondary btn-sm p-1' to={`/admins-edit/${admin.admin_id}`}>
					<i className="fa fa-edit"></i> {t('edit')}
				</Link>
			]
		}),
		directions: ['ltr', '', '', '', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const getAdmins = async () => {
		let body = {
			page: pageNumber,
			count: pageCounter
		};
		let response = await _post('/admins/admin/getAll', body);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_admins);
				setAdmins(response.data.admins);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);

	useEffect(() => {
		getAdmins();
	}, []);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t('admins')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={adminsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default AdminsList;
